<template>
  <div class="crud-source-client--container no-select">
    <div  v-if="checkPermission('create_source_client')" class="crud-source-client--title">Добавить источник</div>
    <div v-if="checkPermission('create_source_client')" class="crud-source-client--new-block">
      <div class="input-block mrg-t-15">
        <label for="">Название источника</label>
        <input
          @focus="newSourceError.name = ''"
          type="text"
          v-model="newSource.name"
        />
        <div class="form-error">{{ newSourceError.name }}</div>
        <div class="hint">Например: <b>Вконтакте, Сайт, Яндекс.Дзен...</b></div>
      </div>
      <div class="input-block mrg-t-15">
        <label for="">Короткое обозначение источника на латинице</label>
        <input
          @focus="newSourceError.code = ''"
          type="text"
          v-model="newSource.code"
        />
        <div class="form-error">{{ newSourceError.code }}</div>
        <div class="hint">
          Например: <b>vk, site, dzen</b>. Используется для добавления в ссылку записи онлайн. <br>
          В данном поле нельзя использовать различные символы (-,@^:_ и т.д...) и цифры, 
          они будут удалены при сохранении
        </div>
      </div>
      <div class="input-block">
        <div @click="submitNew" class="btn btn-sm btn-success">Добавить</div>
      </div>
    </div>
    <div class="crud-source-client--title mrg-t-15">Список источников</div>
    <div v-if="list.length === 0" class="crud-source-client--empty-block mrg-t-15">
      Список пока что пуст
    </div>
    <div v-if="list.length > 0" class="crud-source-client--list-block mrg-t-15">
      <div class="table--container">
        <div class="table--header center">
          <div class="name">Название источника</div>
          <div class="code">Короткое обозначение</div>
          <div v-if="checkPermission('delete_source_client')" class="delete">Удалить</div>
        </div>
        <div class="table--rows">
          <div class="table--row center" v-for="item in list" :key="item.id">
            <div class="name">{{item.name}}</div>
            <div class="code">{{item.code}}</div>
            <div v-if="checkPermission('delete_source_client')" class="delete">
              <div @click="deleteSource(item.id)" class="btn btn-sm btn-danger">
                <f-awesome icon="times"></f-awesome>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <popup
      :closeButton="deleteSourcePopup.closeButton"
      :show="deleteSourcePopup.show"
      :actionButton="deleteSourcePopup.actionButton"
      :actionClass="deleteSourcePopup.actionClass"
      @closePopup="closeDeleteSourcePopup"
      @actionPopup="deleteSourceSubmit"
    >
      <div slot="header">Удаление источника</div>
      <div slot="body">
        <div>
          Источник будет удален без возможности восстановления.
        </div>
        <div class="mrg-t-10">
          Вы можете изменить источники привлечения у тех клиентов и записей, которым
          уже присвоен удаляемый источник, либо просто удалить его без замены,
          тогда он будет очищен у тех клиентов и записей, которым был присвоен
        </div>
        <div class="mrg-t-15">
          <div class="input-block">
            <label>Выбрать новый источник для клиентов и записей, вместо старого</label>
            <select v-model="replaceSourceId">
              <option 
                v-for="item in freeSources" 
                :key="item.id" 
                :value="item.id"
              >
                {{item.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </popup>

  </div>
</template>

<script>
import Validator from "../../libraries/Validator";
import Hints from "@/components/Hints";
import PhoneNumber from "../../PhoneNumber";
import Popup from "../../Popup.vue";
import permissionMixin from "@/components/mixins/Permissions";
import sourceRepository from "../../../repositories/source";

const validator = new Validator();

export default {
  name: "CrudSourceClient",
  components: { PhoneNumber, Hints, Popup },
  mixins: [permissionMixin],
  data() {
    return {
      list: [],
      newSource: {
        name: '',
        code: ''
      },
      newSourceError: {
        name: '',
        code: ''
      },
      deleteSourcePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedSourceId: 0,
      replaceSourceId: 0
    };
  },
  props: {
    
  },
  watch: {
    
  },
  computed: {
    validateNew() {
      let errorCount = 0;
      this.vName().result === "error" ? errorCount++ : "";
      this.vCode().result === "error" ? errorCount++ : "";

      return errorCount;
    },
    freeSources(){
      let result = [];
      result[result.length] = {
        id: 0,
        name: 'Очистить данный источник у клиентов и записей'
      };
      for(let key in this.list){
        if(+this.list[key].id !== +this.deletedSourceId){
          result[result.length] = this.list[key];
        }
      }
      return result;
    }
  },
  methods: {
    deleteSourceSubmit(){
      this.$store.dispatch("startPreloader");

      sourceRepository.delete({
        deleted_id: this.deletedSourceId,
        replace_id: this.replaceSourceId
      }).then(resp => {
        this.list = resp.data;
        this.deletedSourceId = 0;
        this.replaceSourceId = 0;
        this.closeDeleteSourcePopup();
        this.$emit("updateSource", resp.data);
        this.$store.dispatch("addNotification", {
          text: "Успешно удалено",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeDeleteSourcePopup(){
      this.deleteSourcePopup.show = false;
    },
    deleteSource(id){
      this.deletedSourceId = id;
      this.deleteSourcePopup.show = true;
    },
    vName() {
      let validate = validator.validate([
        {
          fieldName: "Название источника",
          value: this.newSource.name,
          type: "required",
          length: 85
        }
      ]);
      validate.result === "error"
          ? (this.newSourceError.name = validate.message)
          : (this.newSourceError.name = "");
      return validate;
    },
    vCode() {
      let validate = validator.validate([
        {
          fieldName: "Короткое обозначение источника",
          value: this.newSource.code,
          type: "required",
          length: 30
        }
      ]);
      validate.result === "error"
          ? (this.newSourceError.code = validate.message)
          : (this.newSourceError.code = "");
      return validate;
    },
    submitNew(){
      if (this.validateNew) {
        return false;
      }
      this.$store.dispatch("startPreloader");

      sourceRepository.add({
        name: this.newSource.name,
        code: this.newSource.code
      }).then(resp => {
        this.list = resp.data;
        this.newSource.name = '';
        this.newSource.code = '';
        this.$emit("updateSource", resp.data);
        this.$store.dispatch("addNotification", {
          text: "Успешно добавлено",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getList(){
      sourceRepository.view().then(resp => {
        this.list = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style scoped lang="less">
.crud-source-client--title{
  font-size: 17px;
  font-weight: 700;
}
.crud-source-client--empty-block{ 
  font-size: 13px;
  color: #F97979;
}
</style>
